export default __webpack_public_path__ + "static/slider8-55f4bc7abeef22927d1cbb1c401833f4.jpg";